document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('[id^="GalleryThumbnails-"]');
  const list = document.querySelector('.product__media-wrapper .thumbnail-list, .product__media-wrapper .product__media-thumbnails');
  
  if (!container || !list) return;

  // Opret cm- pile
  const prevBtn = document.createElement('button');
  prevBtn.className = 'cm-scroll-arrow cm-arrow-prev';
  prevBtn.setAttribute('type', 'button');
  prevBtn.setAttribute('aria-label', 'Forrige billede');
  
  const nextBtn = document.createElement('button');
  nextBtn.className = 'cm-scroll-arrow cm-arrow-next';
  nextBtn.setAttribute('type', 'button');
  nextBtn.setAttribute('aria-label', 'Næste billede');

  container.appendChild(prevBtn);
  container.appendChild(nextBtn);

  // Styrer pilene visuelt og tilføjer/fjerner cm-at-bottom klassen
  function toggleArrowsAndHeights() {
    const thumbnails = Array.from(list.querySelectorAll('.thumbnail'));
    if (thumbnails.length === 0) return;

    const currentIndex = thumbnails.findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
    const scrollTop = list.scrollTop;
    const scrollHeight = list.scrollHeight;
    const clientHeight = list.clientHeight;

    // 1. Top-pil: Forsvinder KUN når man står på det absolut første billede (indeks 0)
    if (currentIndex <= 0) {
      prevBtn.classList.remove('cm-is-visible');
    } else {
      prevBtn.classList.add('cm-is-visible');
    }
    
    // 2. Bund-pil: Skjul hvis vi står på sidste billede ELLER hvis bunden er nået visuelt
    const isBottom = currentIndex === thumbnails.length - 1 || (scrollHeight - scrollTop <= clientHeight + 15);
    
    if (isBottom) {
      nextBtn.classList.remove('cm-is-visible');
      list.classList.add('cm-at-bottom');
    } else {
      nextBtn.classList.add('cm-is-visible');
      if (scrollTop < scrollHeight - clientHeight - 20) {
        list.classList.remove('cm-at-bottom');
      }
    }
  }

  // CM-LØSNING: Denne funktion overvåger live hvilket indeks der er aktivt,
  // uanset OM der er trykket på en pil, eller klikket direkte på en thumbnail.
  function checkActiveIndexAndScroll() {
    const thumbnails = Array.from(list.querySelectorAll('.thumbnail'));
    if (thumbnails.length === 0) return;

    const currentIndex = thumbnails.findIndex(thumb => thumb.getAttribute('aria-current') === 'true');

    // Hvis det aktive element er det 5. billede (indeks 4) eller derover, tvinger vi den i bund
    if (currentIndex >= 4) {
      setTimeout(function() {
        list.classList.add('cm-at-bottom');
        const maxScroll = list.scrollHeight - list.clientHeight;
        list.scrollTo({
          top: maxScroll,
          behavior: 'smooth'
        });
      }, 30);
    } 
    // Hvis det aktive element er det 4. billede (indeks 3) eller mindre, ruller vi op til toppen
    else if (currentIndex <= 3 && currentIndex !== -1) {
      list.classList.remove('cm-at-bottom');
      nextBtn.classList.add('cm-is-visible');
      
      setTimeout(function() {
        list.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 30);
    }

    toggleArrowsAndHeights();
  }

  // Skifter aktivt produktbillede (Kører når der trykkes på cm-pilene)
  function changeActiveThumbnail(direction) {
    const thumbnails = Array.from(list.querySelectorAll('.thumbnail'));
    if (thumbnails.length === 0) return;
    
    const currentIndex = thumbnails.findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
    let targetIndex = currentIndex + direction;
    
    if (targetIndex < 0) targetIndex = 0;
    if (targetIndex >= thumbnails.length) targetIndex = thumbnails.length - 1;
    
    if (targetIndex !== currentIndex) {
      const targetThumb = thumbnails[targetIndex];
      targetThumb.click(); // Shopifys eget script trigges, hvorefter vores Observer opfanger det
    }
  }

  nextBtn.addEventListener('click', function() {
    changeActiveThumbnail(1);
  });

  prevBtn.addEventListener('click', function() {
    changeActiveThumbnail(-1);
  });

  list.addEventListener('scroll', toggleArrowsAndHeights, { passive: true });
  
  // Start tilstandstjek
  toggleArrowsAndHeights();

  // MutationObserveren lytter nu efter ALT aktivitet på 'aria-current' (Klasseændringer fra klik)
  // og fyrer checkActiveIndexAndScroll af synkront.
  const observer = new MutationObserver(function() {
    checkActiveIndexAndScroll();
    toggleArrowsAndHeights();
  });
  
  const thumbnailsList = list.querySelectorAll('.thumbnail');
  thumbnailsList.forEach(thumb => observer.observe(thumb, { attributes: true, attributeFilter: ['aria-current', 'class'] }));
  
  setTimeout(toggleArrowsAndHeights, 300);
});